(() => {
  if (window.__productTitleAbtestInit) return;
  window.__productTitleAbtestInit = true;

  const FLAG_KEY = 'TOKU_PRODUCT_TITLE_ABTEST_ENABLED';
  const SWAP_CLASS = 'ab-test-product-title-swap';

  const isEnabled = () => window[FLAG_KEY] !== false;

  const enableAbtest = () => {
    document.documentElement.classList.add(SWAP_CLASS);
  };

  const syncProductTitleAbtest = () => {
    if (!isEnabled()) return;

    enableAbtest();

    document.querySelectorAll('[data-product-title-abtest]:not([data-abtest-filled])').forEach((target) => {
      const section = target.closest('[data-section-type="product"], [data-section-id]') || document;
      const source = section.querySelector('[data-product-description-source]');
      if (!source) return;

      const strongEl = source.querySelector('strong');
      if (!strongEl) return;

      const strongText = strongEl.textContent.trim();
      if (!strongText) return;

      target.replaceChildren(strongEl.cloneNode(true));
      target.dataset.abtestFilled = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncProductTitleAbtest, { once: true });
  } else {
    syncProductTitleAbtest();
  }

  const selectGalleryImage = (phrase) => {
    const needle = String(phrase || '').trim().toLowerCase();
    if (!needle) return;

    const gallery = document.querySelector('product-images');
    if (!gallery) return;

    const scope = gallery.querySelector('[data-product-media-list]') || gallery;
    const slide = Array.from(scope.querySelectorAll('[data-slide][data-media-id]')).find((element) => {
      if (element.classList.contains('is-flavor-hidden')) return false;

      const alt = element.getAttribute('data-slider-alt') || element.querySelector('img')?.getAttribute('alt') || '';
      return alt.toLowerCase().includes(needle);
    });
    const mediaId = slide?.getAttribute('data-media-id');
    if (!mediaId) return;

    gallery.dispatchEvent(
      new CustomEvent('theme:media:select', {
        bubbles: true,
        detail: { id: mediaId },
      }),
    );
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-product-gallery-image]');
    if (!trigger) return;

    event.preventDefault();
    selectGalleryImage(trigger.getAttribute('data-product-gallery-image'));
  });
})();
